<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}

@font-face {
    font-family: 'Gerbera';
    src: url('../content/font/Gerbera-Light.otf');
}
@font-face {
    font-family: 'GerberaBold';
    src: url('../content/font/Gerbera-Medium.otf');
}


html{
   background:linear-gradient(
      rgba(0, 0, 0, 0.6), 
      rgba(0, 0, 0, 0.6) ), url('../content/img/bg.png');
  background-size: contain;
  background-attachment: fixed;

  background-position: top, 0 150px;
  background-repeat: no-repeat;
  height:100%;
  overflow-x: hidden;
}

body{
    width: 100%;
    height: 100%;
    overflow-x: hidden;

}

@media only screen and (max-width: 600px) {
    html{
      background: #666666;
    }
}

body {
  min-height: 100vh;
      text-align: center;
}
#app {
  font-family: 'Gerbera', 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 20px 0 50px;
  color: #2c3e50;
  display:inline-block;
}


#site-navigation a, #footer-sidebar a {
            font-family: -apple-system,Roboto,Arial,"Helvetica Neue",Helvetica,sans-serif;
        }
        /*HEADER*/


        header, footer {
            width: 100%;
            min-width: 920px;
        }
        footer{
          position: absolute;
          bottom: 0!important;
        }
        
        #site-navigation {
            background: #db3727;
            margin: 0;
            height: 44px;
            line-height: 44px;
            width: 100%;
            min-width: 920px;
        }


        #menu-header {
            width: 920px;
            margin: 0 auto;
        }

        .main-navigation {
            border: none;
        }

        .main-navigation a {
            color: #fff;
            font-size: 15px;
            padding: 0 10px;
        }

        .main-navigation a:hover {
            color: #db3727;
            border: none;
            background: #fff;
        }

        .main-navigation ul li.autoru-logo {
            width: 130px;
            margin-right: 20px;
        }

        .autoru-logo a {
            background: url(data:image/svg+xml;base64,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) no-repeat 50% 45%;
            background-size: 100px;
            color: transparent;
        }

        .autoru-logo a:hover {
            background: url(data:image/svg+xml;base64,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) no-repeat 50% 45%;
            background-size: 100px;
            color: transparent;
        }

        .main-navigation li a {
            line-height: 44px;
            height: 44px;
            margin: 0;
            border: none;
            padding: 0 15px;
        }

        .apostrophe-social li a {
            border: none;
            padding: 0 10px;
        }

        .main-navigation li a {
            line-height: 44px;
            height: 44px;
            margin: 0;
            border: none;
            padding: 0 15px;
            font-weight: 600;
        }
        .main-navigation ul li {
            margin: 0;
        }

        .main-navigation li {
            display: inline-block;
            position: relative;
        }
        ul.apostrophe-2-navigation {
            display: block;
            box-sizing: border-box;
        }
        .main-navigation ul {
            list-style: none;
            padding-left: 0;
        }

        #site-navigation {
            background: #db3727;
            margin: 0;
            height: 44px;
            line-height: 44px;
            width: 100%;
        }
        .main-navigation {
            border: none;
        }
        nav, footer, .main-navigation {
            font-family: -apple-system,Roboto,Arial,"Helvetica Neue",Helvetica,sans-serif;
        }
        @media (min-width: 768px) {
            .main-navigation {
                margin: 0 0 3.0303%;
                position: relative;
                z-index: 100;
            }
        }
        .main-navigation ul li.autoru-logo {
            width: 130px;
            margin-right: 20px;
        }
        .main-navigation li a {
            line-height: 44px;
            height: 44px;
            margin: 0;
            border: none;
            padding: 0 15px;
        }
        .main-navigation a {
            display: block;
            position: relative;
            text-decoration: none;
        }

        nav.main-navigation .apostrophe-2-navigation li.sell-link {
            display: block;
            float: right;
            margin: 0;
        }

        nav.main-navigation .apostrophe-2-navigation li.sell-link a {
            background: #5b0 url(https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/plus-sell.svg) 13px center no-repeat;
            background-size: 22px 22px;
            padding-left: 40px;
        }

        li.sell-link a {
            font-size: 13px;
        }

        .main-navigation a:hover {
            color: #db3727;
            border: none;
            background: #fff;
        }

        nav.main-navigation .apostrophe-2-navigation li.sell-link a:hover {
            background: #fff url(https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/plus-sell-red.svg) 13px center no-repeat;
        }
        @media only screen and (max-width: 920px) and (min-width: 767px) {
            #menu-header {
                width: 100%;
            }
        }

        .autoru-logo a:hover {
            background: url(https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/logo.svg) no-repeat 50% 45%;
            background-size: 100px;
            color: transparent;
        }


        @media only screen and (max-width: 920px) {

            header, footer {
                width: 100%;
                min-width: 100vw;
            }

            #site-navigation {
                width: 100%;
                min-width: 100vw;
            }

            #menu-header {
                width: 100%;
            }
            #menu-header li:nth-child(2),
            #menu-header li:nth-child(3),
            #menu-header li:nth-child(4),
            #menu-header li:nth-child(5) {
                display: none;
            }
        }

        /*HEADER END*/

         /*FOOTER*/

        .site-footer {
            padding: 0 20px;
            background: #000;
            min-width: 920px;
            box-sizing: border-box;
        }

        .site-footer .widget-area {
            border: none;
            padding: 30px 0;
            width: calc(100% - 40px);
            margin: 0 auto;
        }

        .site-footer .widget-area .widget {
            padding: 0;
        }

        .site-footer .widget-area #menu-footer {
            margin-bottom: 0;
        }


        .site-footer .widget-area #menu-footer a {
            text-decoration: none;
            font-size: 13px;
            line-height: 18px;
            color: rgba(255,255,255,.5);
            transition: color .3s ease;
        }
        .site-footer .widget-area #menu-footer a:hover {
            color: rgba(255,255,255,.85);
        }

        .site-footer .widget-area li:after {
            content: none;
        }
        .site-footer .widget-area li {
            padding-right: 2px;
            margin: 0;
        }

        .site-footer .widget.widget_text {
            display: inline-block;
            font-size: 13px;
            line-height: 18px;
            color: rgba(255,255,255,.5);
        }

        .site-footer .widget.widget_nav_menu {
            display: inline-block;
            padding-left: 25px;
        }

        #footer-sidebar {
            text-align: left;
            position: relative;
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(3) a,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(4) a,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(5) a,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(6) a,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(7) a {
            background: #000 no-repeat 50% 50%;
            background-size: 18px;
            color: transparent!important;
            opacity: .36;
            width: 18px;
            height: 18px;
            display: inline-block;
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(3) a:hover,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(4) a:hover,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(5) a:hover,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(6) a:hover,
        #menu-footer .menu-item.menu-item-type-custom:nth-child(7) a:hover {
            opacity: .5;
        }
        #menu-footer .menu-item.menu-item-type-custom:nth-child(7) a:hover {
            opacity: 1;
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(3) a {
            background-image: url('https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/vk_color_white.svg');
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(4) a {
            background-image: url('https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/fb_color_white.svg');
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(5) a {
            background-image: url('https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/ok_color_white.svg');
        }

        #menu-footer .menu-item.menu-item-type-custom:nth-child(6) a {
            background-image: url('https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/twi_color_white.svg');
        }
        #menu-footer .menu-item.menu-item-type-custom:nth-child(7) a {
            background-size: 76px 29px;
            width: 76px;
            height: 29px;
            background-image: url('https://yastatic.net/yandex-autoru-frontend-gifs/images/blog/yandex.svg');
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            padding-right: 25px;
        }

        .site-footer .widget.widget_text {
            display: inline-block;
            font-size: 13px;
            line-height: 18px;
            color: rgba(255,255,255,.5);
        }
        .site-footer .widget-area .widget {
            padding: 0;
        }
        .site-footer .widget-area .widget {
            border-top: none;
            clear: left;
            margin: 0;
        }

        .site-footer .widget.widget_nav_menu {
            display: inline-block;
            padding-left: 25px;
        }
        .site-footer .widget-area .widget {
            padding: 0;
        }

        .site-footer .widget-area .widget {
            border-top: none;
            clear: left;
            margin: 0;
        }

        .site-footer .widget-area #menu-footer {
            margin-bottom: 0;
        }
        ul {
            list-style-type: none;
        }
        ul, ol {
            margin: 0 0 1.5em 0;
        }

        .site-footer .widget-area li {
            padding-right: 2px;
            margin: 0;
        }
        .site-footer .widget-area li {
            display: inline-block;
        }

        .site-footer .widget-area #menu-footer a {
            text-decoration: none;
            font-size: 13px;
            line-height: 18px;
            color: rgba(255,255,255,.5);
            transition: color .3s ease;
        }

        .site-footer .widget-area .widget {
            border-top: none;
            clear: left;
            margin: 0;
        }

        .site-footer .widget-area #footer-sidebar {
            clear: both;
            line-height: 1.5;
            margin: 0 auto;
            max-width: 800px;
        }

        @media only screen and (max-width: 920px) {

          footer{
          position: fixed;
          bottom: 0;
        }
            .site-footer {
                width: 100%;
                min-width: 100vw;
                padding: 0 20px;
                background: none;
            }

            .site-footer .widget-area {
                border-top: 1px solid rgba(0,0,0,.1);
                padding: 20px 0;
                width: 100%;
            }

            #footer-sidebar {
                text-align: left;
            }

            .site-footer .widget.widget_text {
                color: rgba(0,0,0,0.5);
            }

            .site-footer .widget.widget_text {
                padding-left: 16px;
            }
            .site-footer .widget.widget_text {
                line-height: 18px;
            }

            .site-footer .widget.widget_nav_menu {
                display: none;
                padding-left: 25px;
            }

            #menu-footer {
                display: none;
            }
        }

        /*FOOTER END*/
</style>



// WEBPACK FOOTER //
// src/App.vue